// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2250":"24728dffdd9e6ca3","8420":"8773b47abbacf674"}[chunkId] + ".css";
};